import React, { useEffect, useState } from "react";
import { GET_LAWYERS } from "../../api/apiAdmin";
import CreateLawyer from "../organisms/abogados/CreateLawyer";
import LawyersTable from "../organisms/abogados/LawyersTable";
import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";

const AbogadosTemplate = () => {
    const [lawyers, setLawyers] = useState();
    const [loading, setLoading] = useState(false);

    const getLawyers = async () => {
		try {
            setLoading(true);
			const lawyersData = await GET_LAWYERS();
            setLawyers(lawyersData);
		} catch (error) {
			console.error(error);
		} finally {
            setLoading(false);
        }
	};

	useEffect(() => {
        getLawyers();
    }, []);

    return(
        <div className="flex flex-col space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/usuarios" },
                        { label: "Defensa Fiscal", to: null },
                    ]}
                />
                <CreateLawyer refetch={getLawyers} />
            </CardHeader>
            <LawyersTable data={lawyers} loading={loading} refetch={getLawyers}/>
        </div>
    )
};

export default AbogadosTemplate;